import snippetsReducer from "rtk-slice"

import { configureStore } from "@reduxjs/toolkit"

export const store = configureStore({
  reducer: {
    snippets: snippetsReducer,
  },
  devTools: false,
})
